export class UnexpectedErrorsResponse extends Error {
  constructor() {
    super('Response returned errors instead of throwing')
  }
}
